export const bibliographiesData = [
  {
    name: "ReactJS",
    author: "Dev Team",
    link: "https://react.dev/",
  },
  {
    name: "TailwindCSS",
    author: "Dev Team",
    link: "https://tailwindcss.com/",
  },
  {
    name: "Figma",
    author: "Dev Team",
    link: "https://www.figma.com/",
  },
  {
    name: "Locomotive",
    author: "Dev Team",
    link: "https://scroll.locomotive.ca/",
  },
  {
    name: "ChatGPT",
    author: "Open AI",
    link: "https://chatgpt.com/",
  },
  {
    name: "Wikimedia",
    author: "Adam Cunningham",
    link: "https://en.wikipedia.org/wiki/Goldbach's_conjecture",
  },
  {
    name: "Veritasium",
    author: "Derek Muller",
    link: "https://youtu.be/x32Zq-XvID4?si=4qAw39I5Q9qq0fWL",
  },
  {
    name: "StackExchange",
    author: "Daniel",
    link: "https://math.stackexchange.com/questions/1112485/how-did-gauss-discover-the-prime-number-theorem",
  },
  {
    name: "ThatsMaths",
    author: "thatsmaths",
    link: "https://thatsmaths.com/2014/02/27/the-prime-number-theorem/",
  },
  {
    name: "Quanta Magazine",
    author: "Alex Kontorovich",
    link: "https://youtu.be/zlm1aajH6gY?si=bPoM84gDcKEo2G8x",
  },
];
